export const education = [
    "BASc",
    "Board Eligible/Residency Trained", 
    "Board-Certified", 
    "BVMS",
    "BVM&S",
    "BVSc",
    "DVM",
    "Internship Trained",
    "JD",
    "MBA",
    "MS",
    "PhD",
    "VMD",
    "Other"
]